import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import PubSub, { topics } from '../../lib/pubsub';

import Top from '../navigation/top';

import Images from '../form/images';
import { FormRow } from '../form/formField';

import util from '../../lib/util';

const initialState = {
    height: 100,
    windowHeight: 0,
};

const FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    serial: { label: 'serial', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    name: { label: 'name', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    model: { label: 'model', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    articleno: { label: 'articleno', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    length: { label: 'length', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    length_key: { label: 'length_key', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    line: { label: 'line', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    line_key: { label: 'line_key', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    purchase_date: { label: 'purchase_date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    received_date: { label: 'received_date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    dealerName: { label: 'dealerName', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    dealerCustomerno: { label: 'dealerCustomerno', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    userFname: { label: 'userFname', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    userLname: { label: 'userLname', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    userAddress1: { label: 'userAddress1', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    userPostalcode: { label: 'userPostalcode', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    userPostalplace: { label: 'userPostalplace', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    userCountry: { label: 'userCountry', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },

    registeredByDealer: { label: 'registeredByDealer', type: 'object', readonly: true, help: 'Field is DealerWeb only.' },
};

@observer
class ConsumerEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
            previewServer: util.getPreviewServer(),
            jwtToken: util.getJwtToken(),
        };
        this.updateTimer = {};
        const { rodregStore } = this.props.stores;
        rodregStore.load(props.serial);

        this.fields = [
            {
                tabname: 'Basics',
                icon: 'fas fa-user-edit',
                fields: ['serial', 'name', 'model', 'articleno', 'length', 'length_key', 'line', 'line_key',
                    'purchase_date', 'received_date', 'dealerName', 'dealerCustomerno',
                    'userFname', 'userLname', 'userAddress1', 'userPostalcode', 'userPostalplace',
                    'userCountry', 'registeredByDealer'].map(f => util.makeField(f, FIELDS)),
            },
        ];
        this.subscriptions();
    }

    subscriptions() {
        PubSub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, (height) => {
            this.setState({ height });
        });
    }

    updateField = async (id, field, value) => {
        const { rodregStore } = this.props.stores;
        rodregStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { rodregStore } = this.props.stores;
        await rodregStore.saveField(id, field, value);
    }

    addArticleImage = async (id, imageObject) => {
        const { rodregStore } = this.props.stores;
        rodregStore.addImage(id, imageObject);
    }

    delArticleImage = async (id, imageId) => {
        const { rodregStore } = this.props.stores;
        rodregStore.delImage(id, imageId);
    }

    render(props) {
        const { height, previewServer, jwtToken } = this.state;
        const { rodregStore } = this.props.stores;
        const { rodreg, saved } = rodregStore;

        let tabIdx = this.fields.findIndex(e => e.tabname === props.tabname);
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return (
            <div>
                <Top {...props} />

                <div class='row'>
                    <div class='col-12'>
                        <div class='d-flex flex-row bd-highlight mb-3'>
                            <div>
                                <a href='/rodregs' class={`mr-2 btn btn-sm btn-warning`}>
                                    <i class={`fas fa-arrow-left mr-1`} />
                                    Back
                                </a>
                            </div>
                            <div class='flex-grow-1'>
                                <h4>Edit: {rodreg.serial}: {rodreg.name}</h4>
                            </div>
                        </div>
                        <ul class='nav nav-tabs mb-2'>
                            {this.fields.map(tab => (
                                <li class='nav-item'>
                                    <a class={`nav-link ${props.tabname === tab.tabname ? 'active' : ''}`}
                                        href={`/rodregs/${props.serial}/${tab.tabname}`}
                                    >
                                        <i class={`${tab.icon} mr-2`} />
                                        {tab.tabname}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        {this.fields[tabIdx].fields.map(field => <FormRow
                            field={field}
                            object={rodreg}
                            saved={saved}
                            updateField={this.updateField}
                        />)}


                    </div>
                </div>
            </div>
        );
    }
}

export default ConsumerEdit;



// WEBPACK FOOTER //
// ./components/rodregs/edit.js